import { render } from "./HomeFAQ.vue?vue&type=template&id=728bf725&scoped=true"
import script from "./HomeFAQ.vue?vue&type=script&lang=js"
export * from "./HomeFAQ.vue?vue&type=script&lang=js"

import "./HomeFAQ.vue?vue&type=style&index=0&id=728bf725&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-728bf725"

export default script